import type { ProblemDetails } from "@spoonity/flags-contract";

/** Thrown by every failed API call; carries the RFC 7807 problem body (CONTRACT §1.1). */
export class ApiError extends Error {
  readonly problem: ProblemDetails;
  readonly status: number;

  constructor(problem: ProblemDetails) {
    super(problem.detail ?? problem.title);
    this.name = "ApiError";
    this.problem = problem;
    this.status = problem.status;
  }

  get code(): string {
    return this.problem.code;
  }
}

export function isVersionConflict(err: unknown): err is ApiError {
  return err instanceof ApiError && err.code === "version_conflict";
}

export function isUnauthorized(err: unknown): err is ApiError {
  return err instanceof ApiError && err.status === 401;
}
